
import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Spinner, Form } from 'react-bootstrap';
import apiService from "../../Common/Configurations/APIService";
import config from '../../Common/Configurations/APIConfig';
import './HajjScreen.css'; 
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from '../../CompanyData/DefaultData';

const hajjImages = {
    hero: 'https://images.unsplash.com/photo-1567993582182-a16ac1173e04?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    packageDefault1: 'https://images.unsplash.com/photo-1610447955358-62d9ad47f892?q=80&w=1935', 
    packageDefault2: 'https://images.unsplash.com/photo-1604424343191-584347898516?q=80&w=1974', 
    packageDefault3: 'https://plus.unsplash.com/premium_photo-1697730312628-69f583f7a46d?q=80&w=1964', 
};


const serviceIcons = { 
    visa: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M1.92.506a.5.5 0 0 1 .434.146L8 6.293l5.646-5.647a.5.5 0 0 1 .708.708L8.707 7l5.647 5.646a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708L7.293 7 .354 1.354a.5.5 0 0 1 .146-.434c.1-.1.234-.146.42-.146z" /><path d="M4.5 0h7a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-15a.5.5 0 0 1 .5-.5" /></svg>,
    ziyarat: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M8.5 2.5a.5.5 0 0 0-1 0V3H6a1 1 0 0 0-1 1v1H4a1 1 0 0 0-1 1v1H2a1 1 0 0 0-1 1v1H.5a.5.5 0 0 0 0 1H1v1a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h1v.5a.5.5 0 0 0 1 0V13h1.5a1 1 0 0 0 1-1v-1H12a1 1 0 0 0 1-1V9h1a1 1 0 0 0 1-1V7h.5a.5.5 0 0 0 0-1H15V5a1 1 0 0 0-1-1h-1V3a1 1 0 0 0-1-1H8.5z" /></svg>,
    support: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z" /></svg>,
    transport: <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16"><path d="M5.52.359A.5.5 0 0 1 6 0h4a.5.5 0 0 1 .48.359l.96 1.841C12.11 2.655 13 3.937 13 5.405v1.816l.96.48a.5.5 0 0 1 .24.421v2.158a.5.5 0 0 1-.289.46l-1.152.42a1 1 0 0 1-1.062-.277l-1.83-2.699a.5.5 0 0 1 .21-.762l1.622-.927V5.405c0-1.138-.642-2.154-1.622-2.618L9.5 1.5H6.5L5.622 2.787C4.642 3.251 4 4.267 4 5.405v1.816l1.622.927a.5.5 0 0 1 .21-.762l-1.83 2.699a1 1 0 0 1-1.062.277l-1.152-.42a.5.5 0 0 1-.289-.46V7.721a.5.5 0 0 1 .24-.421l.96-.48V5.405c0-1.468.89-2.75 2.04-3.206z" /><path d="M1 11a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm3-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z" /></svg>
};

const formatDateSimple = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

const HeroSectionHajj = () => {
    const landingData = useContext(LandingContext);
    const navigate = useNavigate();
    const [fromOrigin, setFromOrigin] = useState('');
    const [year, setYear] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [itemSelected, setItemSelected] = useState(false);
    const searchContainerRef = useRef(null);
    const currentYear = new Date().getFullYear();
    const travelYears = [currentYear, currentYear + 1, currentYear + 2, currentYear + 3];

    useEffect(() => {
        if (fromOrigin.trim() === '' || !DefaultData.DEFAULTCOMPANYID || itemSelected) {
            setSuggestions([]);
            return;
        }
        const delayDebounceFn = setTimeout(() => {
            const fetchSuggestions = async () => {
                setIsSearching(true);
                try {
                    const resourceUrl = `${config.GETORIGINSEARCH}?keyword=${fromOrigin}&companyId=${DefaultData.DEFAULTCOMPANYID}`;
                    const response = await apiService.getAll(resourceUrl);
                    setSuggestions(response || []);
                } catch (error) {
                    setSuggestions([]);
                } finally {
                    setIsSearching(false);
                }
            };
            fetchSuggestions();
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [fromOrigin, itemSelected]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
                setSuggestions([]);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSearch = (e) => {
        e.preventDefault();
        setSuggestions([]);
        const query = new URLSearchParams({ fromOrigin, year }).toString();
        navigate(`/hajj-packages/search?${query}`); 
    };

    const handleSuggestionClick = (suggestion) => {
        setItemSelected(true);
        setFromOrigin(suggestion.fromOriginName);
        setSuggestions([]);
    };

    const handleInputChange = (e) => {
        setItemSelected(false);
        setFromOrigin(e.target.value);
    };

    const heroStyle = {
        backgroundImage: landingData ? `url(${landingData.umrahBackgroundSrc})` : `url(${hajjImages.hero})`,
    };
    const searchButtonStyle = {
        backgroundColor: DefaultData.THEMECOLOR1,
        borderColor: DefaultData.THEMECOLOR1
    };

    return (
        <div className="hajj-hero-section" style={heroStyle}>
            <div className="hero-overlay"></div>
            <Container className="hero-content">
                <h1 className="display-3 fw-bold text-white">Answer the Call to Hajj</h1>
                <p className="lead mb-5">Discover packages for the journey of a lifetime.</p>
                <div className="hero-search-container">
                    <Form onSubmit={handleSearch} className="hajj-search-bar">
                        <Row className="g-3 align-items-end">
                            <Col md={5} ref={searchContainerRef} style={{ position: 'relative' }}>
                                <Form.Label>Departure City</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="e.g., Mumbai, Delhi, Jeddah"
                                    value={fromOrigin}
                                    onChange={handleInputChange}
                                    autoComplete="off"
                                />
                                {(suggestions.length > 0 || isSearching) && (
                                    <div className="autocomplete-suggestions">
                                        {isSearching && <div className="suggestion-item">Searching...</div>}
                                        {!isSearching && suggestions.map(suggestion => (
                                            <div
                                                key={suggestion.fromOriginId}
                                                className="suggestion-item"
                                                onClick={() => handleSuggestionClick(suggestion)}
                                            >
                                                {suggestion.fromOriginName}
                                            </div>
                                        ))}
                                        {!isSearching && suggestions.length === 0 && fromOrigin.trim() !== '' && (
                                            <div className="suggestion-item">No results found</div>
                                        )}
                                    </div>
                                )}
                            </Col>
                            <Col md={4}>
                                <Form.Label>Year of Travel</Form.Label>
                                <Form.Select value={year} onChange={(e) => setYear(e.target.value)}>
                                    <option value="">Any Year</option>
                                    {travelYears.map(y => <option key={y} value={y}>{y}</option>)}
                                </Form.Select>
                            </Col>
                            <Col md={2}>
                                <Button type="submit" className="w-100" style={searchButtonStyle}>Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </Container>
        </div>
    );
};

const WhyChooseUsSection = () => (
    <section className="py-5 bg-light-green">
        <Container>
            <h2 className="section-title text-center mb-5">Your Pilgrimage, Our Priority</h2>
            <Row className="g-4 text-center">
                <Col md={3} xs={6}><div className="service-card"><div className="service-icon">{serviceIcons.visa}</div><h5 className="mt-3">Hassle-Free Visa</h5><p className="small">We handle all documentation for a smooth process.</p></div></Col>
                <Col md={3} xs={6}><div className="service-card"><div className="service-icon">{serviceIcons.ziyarat}</div><h5 className="mt-3">Guided Ziyarat</h5><p className="small">Visit historical holy sites with our expert guides.</p></div></Col>
                <Col md={3} xs={6}><div className="service-card"><div className="service-icon">{serviceIcons.transport}</div><h5 className="mt-3">Comfortable Transport</h5><p className="small">Air-conditioned buses for all your travel needs.</p></div></Col>
                <Col md={3} xs={6}><div className="service-card"><div className="service-icon">{serviceIcons.support}</div><h5 className="mt-3">24/7 On-Ground Support</h5><p className="small">Our team is always there to assist you in Saudi Arabia.</p></div></Col>
            </Row>
        </Container>
    </section>
);

const HajjPackagesSection = ({ packages }) => (
    <section className="py-5">
        <Container>
            <h2 className="section-title text-center mb-5">Our Popular Hajj Packages</h2>
            {packages && packages.length > 0 ? (
                <Row xs={1} md={2} lg={3} className="g-4">
                    {packages.map(pkg => (
                        <Col key={pkg.packageId}>
                            <Card className="hajj-package-card h-100">
                                <div className="package-image-container">
                                    <Card.Img variant="top" src={pkg.imageSrc} alt={pkg.packageName} />
                                    <div className="origin-badge"><i className="ri-map-pin-2-fill"></i> From {pkg.fromOrigin}</div>
                                </div>
                                <Card.Body className="d-flex flex-column">
                                    <Card.Title className="fw-bold mb-2">
                                        <Link to={`/hajj-details/${pkg.packageId}`} className="card-title-link">{pkg.packageName}</Link>
                                    </Card.Title>
                                    <div className="package-meta-info my-3">
                                        <div className="meta-item" title="Package Duration"><i className="ri-calendar-2-line"></i> Duration: <strong>{pkg.duration}</strong></div>
                                        <div className="meta-item" title="Group Size"><i className="ri-group-line"></i> Group Size: <strong>{pkg.noOfPersons} Persons</strong></div>
                                    </div>
                                    {pkg.inclusions.length > 0 && (
                                        <div className="inclusions small mb-3"><p className="mb-1"><strong>Includes:</strong> {pkg.inclusions.join(' • ')}</p></div>
                                    )}
                                    <div className="mt-auto">
                                        <div className="package-start-date text-muted small mb-2"><i className="ri-calendar-check-line"></i> Starts: {formatDateSimple(pkg.packageStartDate)}</div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <span className="small text-muted">Starting from</span>
                                                <div className="price-tag">{pkg.currency} {pkg.price.toLocaleString('en-IN')}</div>
                                            </div>
                                            <Button as={Link} to={`/hajj-details/${pkg.packageId}`} variant="primary">View Details</Button>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            ) : (
                <p className='text-center'>No Hajj packages found at the moment.</p>
            )}
        </Container>
    </section>
);

const HajjScreen = () => {
    const [packages, setPackages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const companyId = DefaultData.DEFAULTCOMPANYID;

    useEffect(() => {
        const getHajjData = async () => {
            setIsLoading(true);
            try {
                const resourceUrl = `${config.GETPACKAGEBYCOMAPANYID}/${companyId}?type=Hajj`;
                const hajjPackagesResponse = await apiService.getAll(resourceUrl);
                const fallbackImages = [hajjImages.packageDefault1, hajjImages.packageDefault2, hajjImages.packageDefault3];

                const formattedPackages = hajjPackagesResponse.data.map((pkg, index) => ({
                    packageId: pkg.packageId,
                    packageName: pkg.packageName || 'Unnamed Package',
                    price: pkg.price || 0,
                    imageSrc: pkg.imageSrc || fallbackImages[index % fallbackImages.length],
                    fromOrigin: pkg.fromOrigin || 'Not Specified',
                    duration: pkg.duration || 'N/A',
                    inclusions: pkg.includes ? pkg.includes.split(',').map(item => item.trim()) : [],
                    currency: pkg.currency || 'INR',
                    packageStartDate: pkg.packageStartDate,
                    noOfPersons: pkg.noOfPersons || 'N/A',
                }));
                setPackages(formattedPackages);

            } catch (error) {
                console.error("Failed to fetch Hajj data:", error);
                setPackages([]);
            } finally {
                setIsLoading(false);
            }
        };

        if (companyId) getHajjData();
    }, [companyId]);

    return (
        <div className="main-content">
            <HeroSectionHajj />
            <main>
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                        <Spinner animation="border" variant="primary" />
                        <span className="ms-3 fs-5">Loading Hajj Packages...</span>
                    </div>
                ) : (
                    <>
                        <WhyChooseUsSection />
                        <HajjPackagesSection packages={packages} />
                    </>
                )}
            </main>
        </div>
    );
};

export default HajjScreen;